import type { PusherService } from "@phurshell/psiapp-frontend-core/infra";
import Pusher from "pusher-js";

export class PusherServiceAdapter implements PusherService {
  private pusher: Pusher;

  constructor(pusherKey: string, cluster: string) {
    this.pusher = new Pusher(pusherKey, { cluster });
  }

  connect(): void {
    this.pusher.connect();
  }

  disconnect(): void {
    this.pusher.disconnect();
  }

  subscribe(channel: string) {
    return this.pusher.subscribe(channel);
  }

  unsubscribe(channel: string, event: string): void {
    this.pusher.unsubscribe(channel);
    this.pusher.unbind(event);
  }
}
